import { Component, ViewChild } from '@angular/core';
import {NavController, ViewController} from 'ionic-angular';
import {SignaturePad} from 'angular2-signaturepad/signature-pad';

@Component({
    selector: 'page-signature',
    templateUrl: 'signpad.html',
})
export class Signpad {
    @ViewChild(SignaturePad) public signaturePad : SignaturePad;

    public signaturePadOptions : Object = {
        'minWidth': 2,
        'canvasWidth': 340,
        'canvasHeight': 200

    };
    public signatureImage : string;
    public blankSignatureImage : string;

    constructor(
        public navCtrl: NavController,
        public viewCtrl: ViewController
    ) {
    }

    canvasResize() {
        let canvas = document.querySelector('canvas');
        this
            .signaturePad
            .set('minWidth', 0.1)
        ;
        this
            .signaturePad
            .set('maxWidth', 1.1)
        ;
        this
            .signaturePad
            .set('penColor',"rgb(50,50,50)" )
        ;

        this
            .signaturePad
            .set('canvasWidth', canvas.offsetWidth);

        this
            .signaturePad
            .set('canvasHeight', canvas.offsetHeight);

        this.blankSignatureImage = this
            .signaturePad
            .toDataURL();
    }


    ionViewDidLoad() {

        this
            .signaturePad
            .clear();
        this.canvasResize();
    }


    dismiss(ret) {
        this.viewCtrl.dismiss(ret);
    }

    drawCancel() {
        this.dismiss(false);
    }

    drawComplete() {

        this.signatureImage = this
            .signaturePad
            .toDataURL();


        if(this.signatureImage != this.blankSignatureImage)
            this.dismiss(this.signatureImage);

    }

    drawClear() {
        this
            .signaturePad
            .clear();
    }


}



// WEBPACK FOOTER //
// ./src/pages/utils/signpad/signpad.ts